import { createActions } from 'reduxsauce'
import { getHTTPClient, showNotification, checkStatusCode } from 'helpers'

export const { Types, Creators } = createActions({
    fetchConferenciaNfceBegin: null,
    fetchConferenciaNfceSuccess: ['postos'],
    fetchConferenciaNfceFailure: ['error'],
})

export const fetchConferencia = (start, end) => dispatch => {
    dispatch(Creators.fetchConferenciaNfceBegin())
    return getHTTPClient()({
        method: 'POST',
        url: '/nfce',
        data: { start, end }
    })
    .then(response => dispatch(Creators.fetchConferenciaNfceSuccess(response.data.postos)))
    .catch(error => {
        checkStatusCode(error.response.status)
        if (error.response) {
            showNotification(error.response.data.message, 'alert-danger')
        } else if (error.request) {
            if (process.env.NODE_ENV === 'development' )
                console.log(error.request)
                showNotification('Ops, algo deu errado, tente novamente em instantes.', 'alert-danger')
        } else {
            showNotification(error.message, 'alert-danger')
        }
        return dispatch(Creators.fetchConferenciaNfceFailure(true))
    })
}